/**
 * Session state for the FTD (first time deposit) card preselect experiment.
 *
 * The card preselect must apply only once per session. The deposit methods page remounts on every
 * navigation back from a method page, so component state and refs are reset too often to act as a
 * guard. This module-level flag survives remounts.
 *
 * Kept in a dedicated module with no imports to avoid circular dependencies between
 * AppCoreProvider (which resets it) and the auto-select hook (which reads and sets it).
 */
let hasRunForSession = false;

export const hasFtdExpRunForSession = () => hasRunForSession;

export const markFtdExpAsRunForSession = () => {
  hasRunForSession = true;
};

export const resetFtdExpSessionFlag = () => {
  hasRunForSession = false;
};
